<template>
  <NuxtLayout name="standard">
    <SSection v-if="legalInfoPageData" :has-separator="false">
      <ConnectifTag :name="CONNECTIF_PAGE_TAGS.OTHERS" />
      <ConnectifTag :name="CONNECTIF_CONTENT_TAGS.OTHERS" />

      <SMarkdown v-bind="markdown" />
    </SSection>
    <SSpacer />
  </NuxtLayout>
</template>

<script setup lang="ts">
// Constants
import {
  CONNECTIF_PAGE_TAGS,
  CONNECTIF_CONTENT_TAGS,
} from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Types
import { type schemaType as legalInfoPageSchemaType } from '~~/shared/api/strapi/legal-info-page/schema'

// Composables
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'

// Apis
import { serverFetch as getLegalOwnerInfoPageData } from '~~/modules/api/strapi/legal-owner-info-page'

// Transformers
import { useToSMarkdown } from '~/composables/transformers/useToSMarkdown'

// Components Props
import type { propsInterface as smarkdownProps } from '~~/modules/design-system/sections/s-markdown.vue'

const { setHeadInfo } = useHeadInfoComposable()

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const dataApiDetail = await getLegalOwnerInfoPageData()

let legalInfoPageData: legalInfoPageSchemaType
let markdown: smarkdownProps

if (dataApiDetail.success && dataApiDetail.success.data) {
  legalInfoPageData = dataApiDetail.success.data

  if (legalInfoPageData) {
    setHeadInfo({
      title: legalInfoPageData.attributes.head.title,
      description: legalInfoPageData.attributes.head.description,
      images: [
        {
          url: legalInfoPageData.attributes.head.image.data.attributes.url,
          alt: legalInfoPageData.attributes.head.title,
        },
      ],
      robotsVisible: true,
    })

    markdown = {
      text: useToSMarkdown().fromStrapiLegalInfoPage(legalInfoPageData),
      responsive: true,
      clear: true,
    }

    const breadCrumbMenuStore = useMenuBreadcrumbStore()
    breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.legal-info'))
  }
} else if (dataApiDetail.error) {
  showErrorPage(dataApiDetail.error as ApiResponseError)
}

sendConnectifPage()
</script>
